import { FC } from 'react';
import { AssistantSummary } from '@/types/assistant';
import AgentAvatar from './AgentAvatar';

interface Props {
  assistant: AssistantSummary;
  onOpen: () => void;
}

/**
 * J07: card de um assistente (classe GENERAL — H.Bot, H.Lex…) no Hub `/agentes`.
 * Badge "Assistente" o distingue dos agentes RAG/SQL; abrir leva pra UI do assistente
 * (não a do chat RAG). Roteamento por tipo fica no caller (`openAssistant`).
 */
const AssistantCard: FC<Props> = ({ assistant, onOpen }) => {
  return (
    <button
      type="button"
      data-testid="assistant-card"
      onClick={onOpen}
      className="text-left rounded-2xl bg-surface-secondary border border-surface-border hover:border-accent/60 hover:shadow-lg transition p-5 group flex items-start gap-4"
    >
      <AgentAvatar avatar={assistant.avatar || 'auto_awesome'} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <h3 className="font-semibold text-content-primary truncate">{assistant.name}</h3>
          <span className="text-xs px-2 py-0.5 rounded-full bg-accent/15 text-accent border border-accent/30 shrink-0">
            Assistente
          </span>
        </div>
        <p className="mt-3 text-sm text-content-secondary line-clamp-3">
          {assistant.description || 'Assistente de IA do h.lab.'}
        </p>
        <span className="mt-3 inline-block text-accent text-sm opacity-0 group-hover:opacity-100 transition">
          Abrir →
        </span>
      </div>
    </button>
  );
};

export default AssistantCard;
